<template>
  <div>
    <div class="nav-type">
      <!-- 评论盒子 -->
      <comment-box
        v-model="comment_show"
        v-if="comment_show"
        :type="comment_box_parmas.type"
        :items="comment_box_parmas.items"
        :replies_items="comment_box_parmas.replies_items"
        @getCommentTxt="getCommentTxt"
        @close="close"
      />
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <!-- 转发列表 -->
            <div v-if="type === 'transpond'" class="transpond_item">
              <div
                :style="{
                  background: 'url(' + item.user.avatar + ') no-repeat',
                  backgroundSize: '100% 100%'
                }"
                class="left_avatar"
              ></div>
              <div class="right_box">
                <p class="nikename">{{ item.user.nickname }}</p>
                <span>{{ item.content }}</span>
                <p class="transpond_time">
                  {{ item.created_at }}
                </p>
              </div>
              <p style="clear: both;"></p>
            </div>

            <!-- 评论列表 -->
            <div v-if="type === 'comment'" class="transpond_item">
              <div
                :style="{
                  background: 'url(' + item.user.avatar + ') no-repeat',
                  backgroundSize: '100% 100%'
                }"
                class="left_avatar"
              ></div>
              <div class="right_box">
                <p class="nikename">{{ item.user.nickname }}</p>
                <span @click="showCommentBox('reply', item)">{{
                  item.content
                }}</span>
                <div v-if="item.replies" class="comment_item_box">
                  <div
                    v-for="(item1, index1) in item.replies"
                    :key="index1"
                    @click="showCommentBox('', item, item1)"
                    class="comment_item"
                  >
                    <span>{{ item1.user.nickname }}</span>
                    &nbsp;{{ item1.content }}
                  </div>
                </div>
                <p class="transpond_time">
                  {{ item.created_at }}
                  <span>
                    <i
                      @click="showCommentBox('reply', item)"
                      class="comment_icon"
                    ></i>
                    <span class="like_num">{{ item.like_num }}</span>
                  </span>
                  <span>
                    <i
                      @click="commentLike(item)"
                      :class="{ like_icon: true, is_like: item.is_like }"
                    ></i>
                    {{ item.reply_num }}
                  </span>
                </p>
              </div>
              <p style="clear: both;"></p>
            </div>

            <!-- 点赞列表 -->
            <div v-if="type === 'like'" class="transpond_item">
              <div
                :style="{
                  background: 'url(' + item.avatar + ') no-repeat',
                  backgroundSize: '100% 100%'
                }"
                class="left_avatar"
              ></div>
              <div class="right_box">
                <p class="nikename">{{ item.nickname }}</p>
              </div>
              <p style="clear: both;"></p>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { List, Cell, PullRefresh, Toast } from "vant";
import {
  getTranspondListApi,
  getCommentListApi,
  getLikeListApi,
  commentsLikeApi,
  cancelCommentsLikeApi
} from "@/api/info";

export default {
  props: {
    navType: {
      type: String
    }
  },
  name: "nav-type",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    commentBox: () => import("./commen-box")
  },
  data() {
    return {
      type: this.navType,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      item_id: this.$route.params.id,
      comment_show: false,
      comment_box_parmas: {
        items: {},
        replies_items: {},
        type: ""
      },
      page: 1
    };
  },

  methods: {
    onLoad() {
      // 异步更新数据
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }

      if (this.type === "transpond") {
        this.getTranspondList().then(res => {
          this.getDataSucceed(res, res.items);
        });
      } else if (this.type === "comment") {
        this.getCommentList().then(res => {
          this.getDataSucceed(res, res.comments);
        });
      } else {
        this.getLikeList().then(res => {
          this.getDataSucceed(res, res.users);
        });
      }
    },

    // 获取列表数据成功后
    getDataSucceed(res, list) {
      if (res.has_more) {
        this.list = this.list.concat(list);
        this.page++;
      } else {
        this.list = this.list.concat(list);
        this.finished = true;
      }
      this.loading = false;
    },

    // 获取转发列表
    getTranspondList() {
      return new Promise((resolve, reject) => {
        getTranspondListApi(this.item_id, { page: this.page })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取评论列表
    getCommentList() {
      return new Promise((resolve, reject) => {
        getCommentListApi(this.item_id, { page: this.page })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取点赞列表
    getLikeList() {
      return new Promise((resolve, reject) => {
        getLikeListApi(this.item_id, { page: this.page })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 评论点赞
    commentLike(item) {
      const id = this.$route.params.id;
      // 点赞
      if (!item.is_like) {
        commentsLikeApi(id, item.id)
          .then(() => {
            item.like_num++;
            item.is_like = true;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        cancelCommentsLikeApi(id, item.id)
          .then(() => {
            item.like_num--;
            item.is_like = false;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    // 显示评论盒子
    showCommentBox(type, item, replies_items) {
      this.comment_box_parmas.items = item;
      this.comment_box_parmas.replies_items = replies_items;
      this.comment_box_parmas.type = type;
      this.comment_show = true;
    },

    // 更新评论内容
    getCommentTxt(res) {
      if (res) {
        Toast.success("操作成功！");
        // 刷新列表
        this.list = [];
        this.onRefresh();
      }
      this.close();
    },

    // 关闭评论盒子
    close() {
      this.comment_show = false;
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.page = 1;
      this.onLoad();
    }
  }
};
</script>

<style scoped>
@import "../assets/comment.css";
</style>
